import { setNonceToElement } from '@pes-ui/utils';
const SCRIPT_OPTIONS = {
  id: 'widgetScript',
  type3d: '3d',
  type360: '360',
  srcType: '.esm.js',
};
export const getNewWidgetType = (data) => {
  let newWidgetType = null;
  const { image360: widgetOptions } = data;
  if (widgetOptions) {
    const { type3d, type360 } = SCRIPT_OPTIONS;
    if (widgetOptions.image3dUrl) {
      newWidgetType = type3d;
    }
    else if (widgetOptions.image360Url) {
      newWidgetType = type360;
    }
  }
  return newWidgetType;
};
export const isScriptAModule = (src) => {
  return src === null || src === void 0 ? void 0 : src.endsWith(SCRIPT_OPTIONS.srcType);
};
export const createWidgetScript = (type, data) => {
  const { type360, id } = SCRIPT_OPTIONS;
  const { image360ScriptSrc, image3dScriptSrc } = data.image360;
  const scriptElement = document.createElement('script');
  const src = type === type360 ? image360ScriptSrc : image3dScriptSrc;
  if (isScriptAModule(src)) {
    scriptElement.setAttribute('type', 'module');
  }
  scriptElement.id = id;
  scriptElement.dataset.type = type;
  scriptElement.setAttribute('async', '');
  scriptElement.setAttribute('src', src);
  setNonceToElement(scriptElement);
  return scriptElement;
};
export const updateWidgetScript = (data) => {
  const { id } = SCRIPT_OPTIONS;
  const newWidgetType = getNewWidgetType(data);
  const scriptElement = document.getElementById(id);
  const currentWidgetType = scriptElement ? scriptElement.dataset.type : null;
  const scriptSrc = scriptElement === null || scriptElement === void 0 ? void 0 : scriptElement.getAttribute('src');
  if (scriptSrc && isScriptAModule(scriptSrc)) {
    scriptElement.setAttribute('type', 'module');
  }
  if (newWidgetType !== currentWidgetType) {
    scriptElement && scriptElement.remove();
    newWidgetType
      && document.body.insertAdjacentElement('beforeend', createWidgetScript(newWidgetType, data));
  }
};
export const removeWidgetScript = () => {
  const { id } = SCRIPT_OPTIONS;
  const scriptElement = document.getElementById(id);
  scriptElement && scriptElement.remove();
};
